import { LOCAL_STORAGE_TYPE, MODE } from '@utils/constants';
import { useSlug, useViewAnalyzer } from '@utils/hooks';
import { setLanguage, setMode } from '../store/slices/configSlice';

import { usePublicEventDetailsBySlug } from '@utils/apiHooks';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { setEventDetails } from '../store/slices/eventSlice';
import { useNavigate, useSearchParams } from 'react-router-dom';

const Routes = ({ children }: { children: React.ReactNode }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const view = useViewAnalyzer();
  const dispatch = useDispatch();
  const { i18n } = useTranslation();

  const [searchParams] = useSearchParams();
  const eventParam = searchParams.get('event') ?? '';

  const eventSlug = useSlug(getFirstSubPath()) ?? eventParam;

  function getFirstSubPath() {
    if (window?.location) {
      const path = window.location.pathname;
      const segments = path.split('/').filter(Boolean);
      return segments.length > 0 ? `/${segments[0]}/` : '/';
    } else {
      return '';
    }
  }

  const { data: eventDetails, isLoading: isEventLoading } =
    usePublicEventDetailsBySlug({
      eventSlug: eventParam || eventSlug,
      enabled:
        !!eventParam ||
        ((view === MODE.EVENT || view === MODE.WEBINAR) && !!eventSlug),
    });

  useEffect(() => {
    switch (view) {
      case MODE.OVERVIEW:
        dispatch(setMode(MODE.OVERVIEW));
        break;
      case MODE.PORTFOLIO:
        dispatch(setMode(MODE.PORTFOLIO));
        break;
      case MODE.EVENT:
        dispatch(setMode(MODE.EVENT));

        if (eventDetails != null && !isEventLoading) {
          const language = eventDetails?.[0]?.language;
          dispatch(setEventDetails(eventDetails));
          dispatch(setLanguage(language));
          window.localStorage.setItem(LOCAL_STORAGE_TYPE.LANGUAGE, language);
          void i18n.changeLanguage(language);
        }

        if ((!eventDetails || eventDetails?.length === 0) && !isEventLoading) {
          navigate(`${t('404-url')}`);
        }

        break;
      case MODE.WEBINAR:
        dispatch(setMode(MODE.WEBINAR));

        if (eventDetails != null && !isEventLoading) {
          const language = eventDetails?.[0]?.language;
          dispatch(setEventDetails(eventDetails));
          dispatch(setLanguage(language));
          window.localStorage.setItem(LOCAL_STORAGE_TYPE.LANGUAGE, language);
          void i18n.changeLanguage(language);
        }
        break;
      default:
        dispatch(setMode(MODE.OVERVIEW));
        break;
    }

    if (!!eventParam && eventDetails != null && !isEventLoading) {
      dispatch(setMode(MODE.EVENT));

      const language = eventDetails?.[0]?.language;
      dispatch(setEventDetails(eventDetails));
      dispatch(setLanguage(language));
      window.localStorage.setItem(LOCAL_STORAGE_TYPE.LANGUAGE, language);
      void i18n.changeLanguage(language);
    }
  }, [dispatch, eventDetails, i18n, isEventLoading, view]);

  return <>{children}</>;
};

export default Routes;
